import React, { Component } from 'react';
import {
  Button,
  Container,
  Col,
  Form,
  FormControl,
  Row,
} from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import { eAlertsCoreAPIEndpoint, ENDPOINTS, formatParcelNumber } from '../../api';

export default class Login extends Component {
  constructor(props) {
    super(props);
    const searchParams = new URLSearchParams(this.props.location.search);
    this.state = {
      email: '',
      errors: {},
      parcelnumber: searchParams.get('parcelnumber')
        ? formatParcelNumber(searchParams.get('parcelnumber'))
        : '',
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    if (this.state.parcelnumber) {
      this.props.history.replace(`/login?parcelnumber=${this.state.parcelnumber}`);
    }
  }

  handleChange(event) {
    this.setState({ email: event.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();

    let loginObject = {
      email: this.state.email,
      parcelnumber: this.state.parcelnumber
    };
    if (this.validate()) {
      eAlertsCoreAPIEndpoint(ENDPOINTS.ACCOUNT)
        .login(loginObject)
        .then((Response) => {
          if (Response.status === 200) {
            const ref = '/email';
            //redirect to email sent page
            this.props.history.push(ref);
          } else if (Response.status === 204) {
            const ref = `/register/${this.state.email}?parcelnumber=${this.state.parcelnumber}`;
            //redirect to register page
            this.props.history.push(ref);
          }
        })
        .catch(() => {
          const ref = '/error';
          this.props.history.push(ref);
        });
    }
  }

  validate() {
    let errors = {};
    let isValid = true;

    if (typeof this.state.email !== 'undefined') {
      var pattern = new RegExp(/.+@.+\..+/i);
      if (!pattern.test(this.state.email)) {
        isValid = false;
        errors['emailAddress'] = 'Please enter valid email address.';
      }
    }

    if (!this.state.email) {
      isValid = false;
      errors['emailAddress'] = 'Please enter your email address.';
    }

    this.setState({
      errors: errors,
    });

    return isValid;
  }

  async loginSendDashboardLink(loginObject) {
    await eAlertsCoreAPIEndpoint(ENDPOINTS.ACCOUNT).login({
      Email: loginObject.email,
      ParcelNumber: loginObject.parcelnumber,
    });
  }

  render() {
    return (
      <Container fluid="md">
        <Helmet>
          <title>Login{process.env.REACT_APP_PAGETITLE_TEXT}</title>
          <meta name="description" content="Log in now to create and manage property eAlerts for Franklin County OH." />
        </Helmet>
        <Row>
          <Col></Col>
          <Col xs={8}>
            <br />
            <h2>Sign Up For or Manage Property eAlerts</h2>
            <br />
            <p className="textup">
              Your Franklin County Auditor’s office is dedicated to maintaining
              accurate and complete property records for the residents and
              businesses of Franklin County. The office is also committed to
              helping property owners better understand and provide feedback
              related to their property records.
            </p>

            <p className="textup">
              As part of this effort, the Auditor’s office offers this Property
              eAlerts tool through which a property owner can sign up to receive
              an automated email alert whenever a change is made to their
              property record (e.g., change in property owner, change in
              property value). To continue signing up for or managing eAlerts
              for this parcel, please enter your email address in the field
              below and click continue. You will then be sent a confirmation
              email containing a link that you must click to complete the
              subscription process for this parcel or to access your Property
              eAlerts dashboard.
            </p>

            <Form onSubmit={this.handleSubmit} noValidate>
              <Form.Group as={Row} className="mb-3">
                <Col sm={9}>
                  <FormControl
                    name="emailAddress"
                    placeholder="Enter Email Address"
                    aria-label="Email Address"
                    aria-describedby="emailAddressError"
                    type="email"
                    value={this.state.email}
                    onChange={this.handleChange}
                  />
                  <Form.Text id="emailAddressError" className="text-danger">
                    {this.state.errors.emailAddress}
                  </Form.Text>
                </Col>
              </Form.Group>
              <Form.Group>
                <Button
                  variant="outline-dark"
                  className="m-1"
                  size="md"
                  onClick={() => this.props.history.goBack()}
                >
                  Cancel
                </Button>
                <Button className="m-1" size="md" type="submit">
                  Continue
                </Button>
              </Form.Group>
            </Form>
          </Col>
          <Col></Col>
        </Row>
      </Container>
    );
  }
}
